<template>
  <div class="home">
    <Navbar />
    <vue-headful title="CHECK CODE" />
    <fish-segment>
      <fish-loader :active="isLoading"></fish-loader>
      <a-row>
        <a-col :xs="0" :sm="6" :md="6"  :lg="6"></a-col>
        <a-col :xs="24" :sm="12" :md="12"  :lg="12">
          <fish-card fluid style="height:160px">
            <div slot="header">CHECK CODE</div>
          <template>
            <a-form style="width:100%" 
             :form="form" @submit="handleSubmit">
             <a-form-item style="width:100%" :validate-status="CodeError() ? 'error' : ''" :help="CodeError() || ''">
                <a-input
                  style="width:100%"
                  autocomplete="off"
                  v-decorator="[
                        'Code',
                        { rules: [{ required: true, message: 'Vui lòng điền CODE HOẶC HASHCODE!' }] },
                        ]"
                  placeholder="Nhập CODE hoặc HASHCODE"
                >
                  <a-icon slot="prefix" type="key" style="color:rgba(0,0,0,.25)" />
                </a-input>
              </a-form-item>
              <a-form-item>
                <a-button
                  type="primary"
                  html-type="submit"
                  :disabled="hasErrors(form.getFieldsError())"
                >
                  <i class="fa fa-search" aria-hidden="true"></i>
                  <span>CHECK</span>
                </a-button>
              </a-form-item>
            </a-form>
        </template>
            <!-- <fish-form inline width="100%">
            <fish-field span="18">
              <fish-input hint="Nhập mã CODE hoặc HASHCODE" :iconLeft="true" icon="fa fa-key"></fish-input>
            </fish-field>
            <fish-button type="primary">
              <i class="fa fa-search" style="margin-right: .5em;"></i>CHECK
            </fish-button>
            </fish-form>-->
          </fish-card>
        </a-col>
        <a-col :xs="0" :sm="6" :md="6"  :lg="6"></a-col>
      </a-row>

      <br />
      <br />
      <a-table
        rowKey="Serial"
        size="small"
        :columns="columns"
        :data-source="TBLdata"
        :pagination="false"
        :scroll="{ x: 600 }"
      >
        <span slot="IsActive" slot-scope="text">
          <a-tag
            :key="text"
            :color="text === true ? 'red':'green'"
          >{{ text==true?"ĐÃ DÙNG":"CHƯA DÙNG" }}</a-tag>
        </span>
        <template slot="Active_Time" slot-scope="text">
          <span v-if="text!=null && text.length>10">{{ text | moment("DD/MM/YYYY HH:mm:ss")}}</span>
        </template>
        <span slot="HashCode" slot-scope="text">{{ text.substr(0,5)+"..."}}</span>
        <span slot="Topup_Amount" slot-scope="text">{{ text | toNumber}}</span>
      </a-table>
      <a-table
        rowKey="Index"
        size="small"
        :columns="MOcolumns"
        :data-source="TBLMOdata"
        :pagination="false"
        :scroll="{ x: 600 }"
      >
        <span slot="Request_Time" slot-scope="text">{{ text | moment("DD/MM/YYYY HH:mm:ss")}}</span>
        <span slot="Scratch_Status" slot-scope="text">
          <a-tag
            :key="text"
            :color="text.toLowerCase()=='success'?'green':
            text.toLowerCase()=='notyet'?'cyan':
            text.toLowerCase()=='enddate'?'yellow':
            text.toLowerCase()=='wrong'?'orange':
            text.toLowerCase()=='duplicate'?'blue':
            text.toLowerCase()=='block'?'pink':'red'"
          >
            {{ text.toLowerCase()=="success"?"Trúng thưởng":
            text.toLowerCase()=="notyet"?"Chưa bắt đầu":
            text.toLowerCase()=="enddate"?"Chương trình kết thúc":
            text.toLowerCase()=="wrong"?"Không chính xác":
            text.toLowerCase()=="duplicate"?"Đã tồn tại":
            text.toLowerCase()=="block"?"Quá 30Topup/ngày":"Không được tham gia"
            }}
          </a-tag>
        </span>
      </a-table>
    </fish-segment>
  </div>
</template>

<script>
function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some((field) => fieldsError[field]);
}
// @ is an alias to /src
import Navbar from "@/components/Navbar.vue";
import { mapActions } from "vuex";

export default {
  name: "Home",
  components: {
    Navbar,
  },
  mounted() {
    this.$nextTick(() => {
      // To disabled submit button at the beginning.
      this.form.validateFields();
    });
  },
  data() {
    return {
      isLoading: false,
      hasErrors,
      form: this.$form.createForm(this, { name: "horizontal_login" }),
      TBLdata: [],
      TBLMOdata: [],
      columns: [
        { title: "Serial", dataIndex: "Serial", key: "Serial" },
        { title: "Code", dataIndex: "Code", key: "Code" },
        { title: "Hash", dataIndex: "HashCode", key: "HashCode",
          scopedSlots: { customRender: "HashCode" }, },
        {
          title: "Trạng thái",
          dataIndex: "IsActive",
          key: "IsActive",
          scopedSlots: { customRender: "IsActive" },
        },
        {
          title: "Ngày Kích Hoạt",
          dataIndex: "Active_Time",
          key: "Active_Time",
          scopedSlots: { customRender: "Active_Time" },
        },
        { title: "Khách hàng", dataIndex: "User_ID", key: "User_ID" },
        {
          title: "Giải thưởng",
          dataIndex: "Topup_Amount",
          key: "Topup_Amount",
          scopedSlots: { customRender: "Topup_Amount" },
        },
      ],
      MOcolumns: [
        { title: "#", dataIndex: "Index", key: "Index",width:"40px" },
        { title: "SĐT", dataIndex: "User_ID", key: "User_ID" },
        { title: "Nội dung", dataIndex: "Message", key: "Message" },
        {
          title: "Ngày nhắn",
          dataIndex: "Request_Time",
          key: "Request_Time",
          scopedSlots: { customRender: "Request_Time" },
        },
        {
          title: "Trạng thái",
          dataIndex: "Scratch_Status",
          key: "Scratch_Status",
          scopedSlots: { customRender: "Scratch_Status" },
        },
        { title: "Giải thưởng", dataIndex: "AwardType", key: "AwardType" },
        // {
        //   title: "Trạng thái",
        //   dataIndex: "IsAvaiable",
        //   key: "IsAvaiable",
        //   scopedSlots: { customRender: "IsAvaiable" },
        // },
      ],
    };
  },
  methods: {
    // Only show error after a field is touched.
    ...mapActions(["API_CheckCode", "API_ChangeCustomerStatus"]),
    CodeError() {
      const { getFieldError, isFieldTouched } = this.form;
      return isFieldTouched("Code") && getFieldError("Code");
    },
    // Only show error after a field is touched.
    async handleSubmit(e) {
      this.TBLMOdata = [];
      this.TBLdata = [];
      e.preventDefault();
      this.form.validateFields(async (err, values) => {
        if (!err) {
          try {
            this.isLoading = true;
            // console.log(values.Code);
            let checkData = await this.API_CheckCode(values.Code);
            console.log(checkData.data.Message);
            if (checkData.data.State == 1) {
              this.TBLdata = [checkData.data.Message.Scratch];
              this.TBLMOdata = checkData.data.Message.lstMO;
              this.TBLMOdata = this.TBLMOdata.filter(
                (st) => (st["Index"] = this.TBLMOdata.indexOf(st) + 1)
              );
            } else {
              this.$message.error(checkData.data.Message, 3000);
            }
            this.isLoading = false;
          } catch (err) {
            console.log(err.message);
            this.isLoading = false;
          }
        }
      });
    },
  },
};
</script>